export const TYPE = {
  CONFIG: 1,
  COURSEWARE: 2,
  MATERIAL: 3,
  ANALYSIS: 4
}

export const PLAY_TYPE = {
  LIST: 1,
  PREVIEW: 2,
  PREVIEWLIST: 3
}